<template>
  <div class="mains">
    <div class="mains_form">
      <img src="../assets/logo.png" style="width: 185px;height: 44px;" />
      <!-- <p class="titles">后台检测管理系统</p> -->
      <p class="titles">商家后台管理系统</p>
      <el-form style="width: 100%;">
        <el-form-item>
          <el-input style="width: 450px;" placeholder="账号" v-model="name" clearable>
            <template slot="prepend">账号</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-input style="width: 450px;" type="password" placeholder="密码" v-model="pwd" clearable>
            <template slot="prepend">密码</template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" style="width: 450px;margin-top: 40px;" @click="login">登录</el-button>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        msg: 'Welcome to Your Vue.js App',
        name: "",
        pwd: ""
      }
    },
    mounted() {
      this.$store.commit('setLogin', false)
      this.$store.commit('setReady', false)
      //回车登录
      var _this = this;
      document.onkeydown = function(e) {
        let key = window.event.keyCode;
        if (key == 13) {
          window.event.preventDefault() //关闭浏览器快捷键
          _this.login(); //
        }
      };
    },
    methods: {
      login() {
        this.Api.open.login({
          name: this.name,
          pwd: this.pwd
        }).then((res) => {
          if (res["code"] === 0) {
            const data = res['data'];
            localStorage.setItem('alias', data['alias'])
            localStorage.setItem('token', data['token'])

            this.$store.commit('setLogin', true)
            this.$router.push({
              name: "home"
            })
          } else if (!isNaN(res["code"])) {
            this.$message.error("account or password is not correct")
          }
        })
      }

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
  .mains {
    position: absolute;
    width: 100%;
    height: 100vh;
    background: linear-gradient(224deg, #CDB3F1 0%, #79B2FD 100%);
  }

  .mains_form {
    width: 450px;
    height: 399px;
    background: #FFFFFF;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    margin: auto;
    position: relative;
    top: 200px;
    padding: 30px 40px;
  }

  .titles {
    width: 192px;
    height: 28px;
    font-size: 24px;
    font-family: FZHei-B01S-Regular, FZHei-B01S;
    font-weight: 400;
    color: #000000;
    line-height: 28px;
    display: block;
    margin-top: 50px;
  }

  h1 {
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue